import React, { FC } from 'react';

import { Box, Grid } from '@mui/material';
import { FormikProps } from 'formik';

import {
  AdminLegendVariant,
  PharmacistLegendVariant,
} from '@pharmaplan/common';

import ViewEditContractDate from '../../../SelfService/Workshifts/WorkshiftForm/ViewEditContract/ViewEditContractDate';
import useExpressBookingLongTermModal from '../../../../hooks/Admin/ExpressBooking/useExpressBookingLongTermModal';
import genericClasses from '../../../../theme/GenericClasses';
import CustomCheckbox from '../../../common/CustomCheckbox';
import { Constants } from '../../../../helpers/Constants';
import CustomButton from '../../../common/CustomButton';
import strings from '../../../../localization';

import ExpressBookingLongTermTimes from './ExpressBookingLongTermTimes';
import styles from '../styles';

interface IExpressBookingLongTermModal {
  type: AdminLegendVariant | PharmacistLegendVariant;
  formFormik: FormikProps<any>;
  isUpdate: boolean;
  openedDate: string;
}

const ExpressBookingLongTermModal: FC<IExpressBookingLongTermModal> = ({
  openedDate,
  formFormik,
  isUpdate,
  type,
}) => {
  const {
    formik,
    handleClose,
    handleCheckboxClick,
    handleSelectAll,
    disabled,
    data,
    isAllSelected,
    selectedIds,
    onDateChange,
  } = useExpressBookingLongTermModal(type, formFormik, isUpdate);

  return (
    <Box sx={styles.modalContainer}>
      <Grid
        sx={styles.subContainer}
        flexDirection="row"
        columnSpacing={4}
        container
      >
        <Grid xs={12} md={4} item>
          <ViewEditContractDate
            openedDate={openedDate}
            onDateChange={onDateChange}
            formik={formik}
            isUpdate={isUpdate}
            sync
          />
        </Grid>
        <Grid md={7} xs={12} item>
          {isUpdate && (
            <Box>
              <CustomCheckbox
                label={strings.selectAll}
                name="selectAll"
                handleChange={handleSelectAll}
                value={isAllSelected}
                id="selectAll"
              />
            </Box>
          )}

          <ExpressBookingLongTermTimes
            data={data}
            type={type}
            formik={formik}
            isUpdate={isUpdate}
            selectedIds={selectedIds}
            handleCheckboxClick={handleCheckboxClick}
          />
        </Grid>
      </Grid>
      <Box sx={[styles.buttonContainer, genericClasses.flex]}>
        <CustomButton
          label={strings.discardChanges}
          onClick={handleClose}
          variant={Constants.variant.outlined}
        />
        <CustomButton
          disabled={disabled && isUpdate}
          customClass={styles.saveButton}
          onClick={formik.handleSubmit}
          label={strings.saveChanges}
        />
      </Box>
    </Box>
  );
};

export default ExpressBookingLongTermModal;
